import { useMemo } from "react";
import config from "@/config";
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { useLogto } from "@logto/react";
import posthog from "posthog-js";
import { useTranslation } from "react-i18next";
import { HiOutlineLogout } from "react-icons/hi";

import { useGetUser } from "@/hooks/api/user/useGetUser";
import useUserInitials from "@/hooks/useUserInitials";
import Avatar from "@/components/atoms/Avatar";
import ListItemDynamic from "@/components/molecules/list-item/ListItemDynamic";

const ProfilePopover = () => {
  const { t } = useTranslation();
  const { signOut } = useLogto();
  const { data: userData } = useGetUser();
  const { userInitials } = useUserInitials();

  const fullName = useMemo(() => `${userData?.first_name} ${userData?.last_name}`, [userData]);

  const _signOut = () => {
    posthog.reset();
    signOut(config.FRONTEND_URL);
  };

  return (
    <Popover className="relative">
      <PopoverButton className={"outline-none"}>
        <Avatar initials={userInitials} color={"primary"} alt={fullName} className={"cursor-pointer"} />
      </PopoverButton>
      <PopoverPanel
        anchor={{ to: "right end", gap: "10px" }}
        className="flex w-80 flex-col rounded-lg border border-secondary bg-primary py-1 shadow-md"
      >
        <div className={"flex gap-2 border-b border-secondary p-3"}>
          <Avatar initials={userInitials} color={"primary"} size={"lg"} alt={fullName} />
          <div className={"flex flex-col gap-1"}>
            <div className="text-sm font-medium text-primary">{fullName}</div>
            <div className="text-xs text-tertiary">{userData?.email}</div>
          </div>
        </div>
        <ListItemDynamic onClick={_signOut} label={t("profile.logout")} icon={HiOutlineLogout} />
      </PopoverPanel>
    </Popover>
  );
};

export default ProfilePopover;
